<div [ngClass]="extraClass">
	<div class="form-group">
		<label *ngIf="labelVisible" class="d-block pb-1 kt-hidden-mobile">&nbsp;</label>
		<button tabindex="{{tabindex}}" [disabled]="buscando || !enabled" [ngClass]="{'kt-spinner kt-spinner--right kt-spinner--md kt-spinner--light': buscando}" style="height: 31px" class="btn btn-sigef">
			{{buscando ? textoProceso : textoNormal}}
		</button>
	</div>
</div> 
